<template>
  <div>
    <div id="loginback">
      <div id="login">
        <form @submit.prevent="register">
          <input id="name" name="name" type="text" v-model="userDetails.name" value="" size="40" class="login_name"
            aria-required="true" aria-invalid="false" placeholder="Contact Name" required>
          <input id="business_name" name="business_name" v-model="userDetails.business_name" type="text" value=""
            size="40" class="login_name" aria-required="true" aria-invalid="false" placeholder="Business Name" required>
          <input id="email" name="email" type="email" v-model="userDetails.email" value="" size="40" class="login_name"
            aria-required="true" aria-invalid="false" placeholder="Email" required>
          <input id="phone" name="phone" type="number" v-model="userDetails.phone" value="" size="40" class="login_name"
            aria-required="true" aria-invalid="false" placeholder="Phone" required>
          <input id="business_id" name="business_id" v-model="userDetails.business_id" type="number" value="" size="40"
            class="login_name" aria-required="true" aria-invalid="false" placeholder="ID Number" required>
          <div>
            <input type="checkbox" id="termsCheckbox" class="terms-checkbox" v-model="termsAccepted">
            <label for="termsCheckbox" class="Back">
              I have read and agree to the
              <a class="Back" href="https://dialer.clickcall.co.il/call-center/Terms.pdf" target="_blank"
                style="cursor: pointer; font-weight: bold; text-decoration: underline;">Terms of Service</a>
            </label>
          </div>
          <input type="submit" value="Create Account" class="login_submit" :disabled="overlay"><br>
        </form>
        <div style="display: flex; justify-content: space-between; width: 95%;">
          <div><span class="Back">Already have an account? <span @click="openLogin"
                style="cursor: pointer; font-weight: bold; text-decoration: underline;">Sign In</span></span></div>
        </div>
        <input id="submitme" name="submitme" value="1" type="hidden">

      </div>
    </div>

    <div class="centered-text">
      <div id="foter">
        <span style="color: white; font-weight: bold; font-size: 25px; margin-left: 60px;">Management System</span>
        <span style="color: #ffb91a; font-weight: bold; font-size: 25px; margin-left: 40px; display: block;">Whatsapp Phone</span>
      </div>
    </div>

    <template>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="84" color="#0d2c6d"></v-progress-circular>
      </v-overlay>
    </template>

    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
    <SuccessDialog v-if="successDialog" v-model="successDialog" @onClose="onSuccessDialogClose"></SuccessDialog>
  </div>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import SuccessDialog from '@/components/auth/SuccessDialog.vue'

export default {

  components: {
    SnackBar,
    SuccessDialog
  },

  data: () => ({
    userName: "",
    password: "",
    termsAccepted: false,
    successDialog: false,
    snackbar: false,
    userDetails: {
      name: "",
      business_name: "",
      phone: "",
      email: "",
      business_id: "",
      recaptchaToken: ""
    },
    snackbarColorBt: "green",
    snacbarText: "",
    overlay: false,
  }),
  
  methods: {
    async register() {
      // Wait until reCAPTCHA has been loaded
      await this.$recaptchaLoaded();

      // Execute reCAPTCHA with action "register"
      this.userDetails.recaptchaToken = await this.$recaptcha('register');
      if (!this.userDetails.recaptchaToken) {
        this.showSnackBar("CAPTCHA validation failed", "red");
        return;
      }

      if (!this.termsAccepted) {
        this.showSnackBar("Please accept the Terms of Service", "red");
        return;
      }

      this.overlay = true;
      let api = process.env.VUE_APP_BASE_URL + "/auth/register";

      try {
        const response = await fetch(api, ApiServices.requestOptions("POST", JSON.stringify(this.userDetails), ""));
        this.overlay = false;
        const jsonObject = await response.json();
        if (response.status >= 400) {
          this.showSnackBar("Registration error: " + jsonObject, "red");
        } else if (response.status === 200) {
          this.successDialog = true
        } else {
          this.showSnackBar("Server error", "red");
        }
      } catch (error) {
        this.overlay = false;
        this.showSnackBar("Error Registering: " + error, "red");
      }
    },
    
    openLogin() {
      this.$emit("openLogin");
    },
    
    onSuccessDialogClose() {
      this.successDialog = false;
      this.openLogin();
    },
    
    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color;
      this.snackbar = true
    },
    
    handleResize() {
      if (window.innerWidth <= 500) {
        this.isResponsive = true;
      } else {
        this.isResponsive = false;
      }
    },
  },
  
  watch: {
    $route() {
      document.title = 'Register | CLICK-CALL'
    },
  },
  
  mounted() {
    document.title = 'Register | CLICK-CALL'
    if (window.innerWidth <= 500) {
      this.isResponsive = true;
    }
    window.addEventListener('resize', this.handleResize);

    setTimeout(() => {
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) {
        badge.style.visibility = 'visible';
      }
    }, 500);
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);

    const badge = document.querySelector('.grecaptcha-badge');
    if (badge) {
      badge.style.visibility = 'hidden';
    }
  },
}
</script>

<style scoped>
#login {
  width: 65%;
  margin: 4% auto;
  min-height: 40%;
}

div#loginback {
  background: linear-gradient(135deg, #0e3280 0%, #0a2357 100%) !important;
  min-height: 55%;
  position: relative;
  z-index: 99;
}

.login_name {
  font-family: 'Roboto', arial !important;
  border: 0 none !important;
  text-align: left !important;
  padding: 3% 5% 3% 13% !important;
  font-size: 1.25em !important;
  width: 95% !important;
  margin-bottom: 3% !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  background-position: 0% -.9vh !important;
  border-radius: .4vw !important;
  background-color: white;
  background-image: url(@/assets/login/icon_u.png);
}

.login_password {
  font-family: 'Roboto', arial;
  border: 0 none;
  text-align: left;
  padding: 3% 5% 3% 13%;
  width: 95%;
  font-size: 1.25em;
  margin-bottom: 6%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: 0% -.9vh;
  border-radius: .4vw;
  background-color: white;
  background-image: url(@/assets/login/icon_s.png);
}

.login_submit {
  font-family: 'Roboto', arial;
  padding: 2%;
  background: #fdb721;
  width: 95%;
  font-size: 1.57em;
  margin-bottom: 2%;
  cursor: pointer;
  border-radius: 8px;
  border: none;
  font-weight: 600;
}

.login_submit:hover:not(:disabled) {
  background: #ffa500;
  transition: background 0.3s ease;
}

.login_submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.forgot {
  text-align: left;
  direction: ltr;
  float: left;
  color: #fff;
  font-size: 1.11em;
  font-family: 'Roboto', arial;
  margin: 1% 0%;
}

.Back {
  text-align: left;
  direction: ltr;
  color: #fff;
  font-size: 1.11em;
  font-family: 'Roboto', arial;
  margin: 1% 0%;
  cursor: pointer;
}

.Back:hover {
  color: #ffb91a;
  transition: color 0.2s ease;
}

.Back a {
  color: #fff;
}

.Back a:hover {
  color: #ffb91a;
}

.terms-checkbox {
  margin-right: 8px;
  cursor: pointer;
}

#rememberme {
  float: left;
  margin: 2% 2% 2%;
}

#foter {
  background-image: url("@/assets/footer.svg");
  background-size: 108% auto;
  background-repeat: no-repeat;
  width: 34%;
  height: 16vh;
  position: absolute;
  bottom: 2%;
  z-index: 0;
}

.centered-text {
  text-align: center;
}

@media only screen and (max-width: 998px) and (min-height: 600px) {
  #login {
    width: 85%;
  }

  .squaredFour label {
    width: 3.5vh;
    height: 3.5vh
  }

  #foter {
    width: 100%;
    position: absolute;
    bottom: 5%;
  }
}

.notification {
  display: block;
  padding: 3% 13% 3% 5%;
  width: 76%;
  border-radius: .4vw;
  margin-bottom: 2vh;
}

/* Import Roboto font */
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
</style>